import { useNavigate } from "react-router-dom/dist";
import "bootstrap/dist/css/bootstrap.min.css"; // Ensure Bootstrap is imported

const UnauthroizedParticipant = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 text-center">
      <div className="bg-danger text-white p-4 rounded shadow-lg">
        <h2 className="mb-3">Access Denied</h2>
        <p className="mb-4">
          You are attempting to access a dashboard of a participant not
          associated with your account. If you believe this to be an error,
          please contact MamFam support.
        </p>
        <button
          className="btn btn-light"
          onClick={() => navigate("/dashboard/user")}
        >
          Return to Dashboard
        </button>
      </div>
    </div>
  );
};

export default UnauthroizedParticipant;
